import { Component, Input, OnChanges } from '@angular/core';

@Component({
    selector: 'app-product-details-attributes',
    templateUrl: './product-details-attributes.component.html',
    styleUrls: ['./product-details-attributes.component.scss']
})
export class ProductDetailsAttributesComponent implements OnChanges {
    @Input() product;

    minThickness = 0;
    maxThickness = 0;
    heightOptions = [];

    constructor() { }

    ngOnChanges(): void {

        // isolate the thickness options
        for (let i = 0; i < this.product.rebuildOptions.length; i++) {
            if (this.product.rebuildOptions[i].id === 7) {
                this.heightOptions = this.product.rebuildOptions[i].options;
            }
        }
        if (this.heightOptions.length > 1) {
            this.minThickness = this.heightOptions[0].size;
            this.maxThickness = this.heightOptions[this.heightOptions.length - 1].size;
        }
        if (this.heightOptions.length === 1) {
            this.minThickness = this.heightOptions[0].name;
        }

    }

}
